import { notificationsApi } from 'entities/notifications';

const getDistributions = notificationsApi.injectEndpoints({
  endpoints: (builder) => ({
    getDistributions: builder.query({
      query: ({ page, size, search }: { page: number; size: number; search: string }) => ({
        url: `/notifications/admin/distributions/?sorting=id&sort_desc=false&page=${page}&size=${size}&search=${search}`,
      }),
      providesTags: ['Distributions'],
    }),
    getDistribution: builder.query({
      query: (id: any) => `/notifications/admin/distributions/${id}`,
    }),
    getCountries: builder.query({
      query: () => '/account/admin/dicts/countries/',
    }),
  }),
});

export const { useGetDistributionsQuery, useGetDistributionQuery, useGetCountriesQuery } = getDistributions;
